import { useEffect, useState } from "react";
import UserService from "services/UserService";
import chatLoading from "assets/img/icons/ani-loading.gif";
import {
  createChannel,
  retreiveData,
  prevMessage,
} from "services/TwilioService";
import { WaterCoolerContext } from "store/contexts/waterCoolerContext";
import { useParams } from "react-router-dom";
import useWaterCoolerMessageAdd from "hooks/useWaterCoolerMessageAdd";
import WaterCoolerPreviewDialog from "components/WaterCoolerPreview/WaterCoolerPreviewDialog";
import {
  scrollToBottomOfWaterCooler,
  connectRoom,
  clearWaterCoolerRoom,
} from "utils/helpers";
import { useHistory } from "react-router-dom";

export default ({
  userId,
  loader = false,
  setLoader = () => {},
  handleChat = null,
}) => {
  const [chatResponse, setChatResponse] = useState(null);
  const history = useHistory();
  const [microphone, setMicrophone] = useState(true);
  const [channelInformation, setChannelInformation] = useState(null);
  const [messageData, setMessageData] = useState();
  const [allMessages, setAllMessages] = useState();
  const messageAdded = useWaterCoolerMessageAdd({ channelInformation });
  const [total, setTotal] = useState("");
  const [room, setRoom] = useState(null);
  const [localVideo, setLocalVideo] = useState(null);
  const [localAudio, setLocalAudio] = useState(null);
  const [notSupported, setNotSupported] = useState(false);
  const [displayChat, setDisplayChat] = useState(false);
  const { user_id } = useParams();
  const [loading, setLoading] = useState(user_id ? true : false);

  useEffect(() => {
    if (!userId && !user_id) {
      return;
    }

    if (chatResponse && userId === parseInt(chatResponse.userId)) {
      return;
    }

    (async () => {
      setLoader(true);
      try {
        var response = await UserService.getPrivateChat(userId ?? user_id);

        var channelData = await createChannel(
          response.data.data.token,
          response.data.data.channel.channel_sid
        );

        var messages = await retreiveData(channelData);
        await joinVideoCall(response);
        setChatResponse({
          chat: response.data.data,
          userId: parseInt(response.data.data.identity),
        });
        setMessageData(messages);
        setAllMessages(messages.items);
        setChannelInformation(channelData);
        setDisplayChat(true);
      } catch (e) {
        console.log(e);
      }

      if (user_id) {
        setLoading(false);
        return;
      }

      setLoader(false);
    })();

    //eslint-disable-next-line
  }, [userId, user_id]);

  useEffect(() => {
    if (messageAdded.message && messageAdded.message !== undefined) {
      setAllMessages(
        Array.from(new Set([...allMessages, messageAdded.message]))
      );
      setTotal(total + 1);

      setTimeout(function () {
        scrollToBottomOfWaterCooler();
      }, 1000);
    }

    //eslint-disable-next-line
  }, [messageAdded.message]);

  useEffect(() => {
    if (!room) {
      return;
    }

    if (!localAudio && !localVideo) {
      room.localParticipant.tracks.forEach(function (trackPublication) {
        if (trackPublication.kind === "audio") {
          setLocalAudio(trackPublication);
          return;
        }

        if (trackPublication.kind === "video") {
          setLocalVideo(trackPublication);
          return;
        }
      });
    }

    //eslint-disable-next-line
  }, [room]);

  const joinVideoCall = async (token) => {
    try {
      // setLoader(true);
      var response2 = await connectRoom(true, true, token);
      if (response2 === undefined) {
        response2 = await connectRoom(true, false, token);
        setNotSupported({
          type: "video",
          description: "Please attach the web cam to see your video.",
        });
      }
      if (response2 === undefined) {
        response2 = await connectRoom(false, false, token);
      }
      setRoom(response2);
      toggleAudio(response2, microphone);
      toggleVideo(response2, false);
      // setLoader(false);
    } catch (e) {
      console.log(e);
    }
  };

  const toggleAudio = async (myRoom, microphoneValue) => {
    if (!myRoom) {
      setMicrophone(!microphone);
      return;
    }
    try {
      await myRoom.localParticipant.audioTracks.forEach((publication) => {
        if (!microphoneValue) {
          publication.track.disable();
          setMicrophone(false);
          return;
        }
        publication.track.enable();
        setMicrophone(true);
      });
    } catch (e) {
      console.log(e);
    }
  };

  const toggleVideo = async (myRoom, value) => {
    // if (!myRoom) {
    //   setMicrophone(!microphone);
    //   return;
    // }
    try {
      await myRoom.localParticipant.videoTracks.forEach((publication) => {
        if (!value) {
          publication.track.disable();
          // setMicrophone(false);
          return;
        }
        publication.track.enable();
        // setMicrophone(true);
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleScroll = async () => {
    try {
      var response = await prevMessage(messageData);
      if (response) {
        setAllMessages(
          Array.from(new Set([...response.items, ...allMessages]))
        );
        setMessageData(response);
      }
    } catch (e) {
      console.log(e);
    }
  };

  async function leaveVideoWaterCooler(setLoader) {
    setLoader(true);
    try {
      await clearWaterCoolerRoom(setRoom);
    } catch (e) {
      console.log(e);
    }
    setLoader(false);
  }

  async function closeJoinWaterCooler() {
    try {
      await Promise.all([
        clearWaterCoolerRoom(setRoom),
        channelInformation.leave(),
      ]);
      if (!handleChat) {
        history.push(`/chat`);
      }
      await handleChat(null);
      setDisplayChat(false);
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <>
      {(loader || loading) && (
        <div className="chatLoader">
          <img src={chatLoading} alt="...loading" />
          <span className="loadingText">
            It may take a while to connect. Please wait
          </span>
        </div>
      )}
      {displayChat && chatResponse && !loader && !loading && (
        <WaterCoolerContext.Provider
          value={{
            microphone,
            toggleAudio,
            localVideo,
            toggleVideo,
            localAudio,
            joinVideoCall,
            leaveVideoWaterCooler,
            setTotal,
            total,
            room,
            notSupported,
            allMessages,
            setAllMessages,
            channelInformation,
            closeJoinWaterCooler,
          }}
        >
          <WaterCoolerPreviewDialog
            closeJoinWaterCooler={closeJoinWaterCooler}
            handleScroll={handleScroll}
          />
        </WaterCoolerContext.Provider>
      )}
    </>
  );
};
